import { createEvent, createStore } from "effector";
import { Role } from "frontend/src/shared/types/role";
var mapRole = function (role) { return ({
    business: {
        owner: role === Role.BusinessOwner,
        employee: role === Role.BusinessEmployee,
    },
    admin: role === Role.Admin,
    rightholder: role === Role.Rightholder,
    guest: role === Role.Guest,
    musicEditor: role === Role.MusicEditor,
}); };
var getRole = function () {
    var _a, _b;
    var role = (_b = (_a = document.querySelector("meta[name='role']")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) !== null && _b !== void 0 ? _b : "";
    if (role === Role.Admin ||
        role === Role.BusinessEmployee ||
        role === Role.BusinessOwner ||
        role === Role.Rightholder ||
        role === Role.Guest ||
        role === Role.MusicEditor) {
        return role;
    }
    return Role.Guest;
};
export var viewerSet = createEvent();
export var viewerReset = createEvent();
export var $clientId = createStore(null);
export var $userId = createStore(-1);
export var $userEmail = createStore("");
export var $userName = createStore(null);
export var $userRoles = createStore(mapRole(getRole()));
$userId.on(viewerSet, function (_, _a) {
    var id = _a.id;
    return id;
}).reset(viewerReset);
$userName.on(viewerSet, function (_, _a) {
    var name = _a.name;
    return name;
}).reset(viewerReset);
$userEmail.on(viewerSet, function (_, _a) {
    var email = _a.email;
    return email;
}).reset(viewerReset);
$clientId.on(viewerSet, function (_, _a) {
    var clientId = _a.clientId;
    return clientId;
}).reset(viewerReset);
$userRoles
    .on(viewerSet, function (_, _a) {
    var role = _a.role;
    return mapRole(role);
})
    .on(viewerReset, function () { return mapRole(Role.Guest); });
